import $xhr from './xhr.js';

window.FutamiCommon = function(vars) {
    vars = vars || {};

    var get = function(name, fallback) {
        return vars[name] || fallback || null;
    };

    return {
        get: get,
        getJson: async function(name, noCache) {
            const options = { type: 'json' };
            if(noCache)
                options.headers = { 'Cache-Control': 'no-cache' };

            const { body } = await $xhr.get(get(name), options);

            return body;
        },
    };
};

FutamiCommon.load = async function(url) {
    if(typeof url !== 'string')
        url = process.env.AMI_FUTAMI_URL + '?t=' + Date.now().toString();

    const { body } = await $xhr.get(url, { type: 'json', headers: { 'Cache-Control': 'no-cache' } });

    return new FutamiCommon(body);
};
